/**
 * Cap the activity scroller to the space left under its top edge inside a
 * bounded layout parent (modal body / grid row).
 *
 * Prefer `boundBottom` from that parent — not `window.innerHeight` —
 * so outlet scroll cannot shrink the pane (top moves, viewport stays fixed)
 * down to the min floor (~160px).
 */
export function activityPaneMaxHeightPx(options: {
    top: number;
    boundBottom: number;
    bottomGapPx?: number;
    minPx?: number;
}): number {
    const bottomGapPx = options.bottomGapPx ?? 16;
    const minPx = options.minPx ?? 160;
    return Math.max(minPx, Math.floor(options.boundBottom - options.top - bottomGapPx));
}

/** Layout ancestor whose bottom tracks with the pane under outlet scroll. */
export function activityPaneBoundElement(el: HTMLElement): HTMLElement | null {
    return (
        el.closest('[data-change-modal-body]') as HTMLElement | null
    ) ?? el.parentElement;
}
